import { env } from './env';

const devApiConfig = {
    SPAY_TEST_SERVER: env.REACT_APP_SPAY_TEST_SERVER,
    SPAY_TEST_COLLECTIONS: env.REACT_APP_SPAY_TEST_COLLECTIONS,
    SPAY_TEST_SETTLEMENT: env.REACT_APP_SPAY_TEST_SETTLEMENT,
    SPAY_TEST_PAYMENT_PAGE: env.REACT_APP_SPAY_TEST_PAYMENT_PAGE,
};

const prodApiConfig = {
    SPAY_PROD_SERVER: env.REACT_APP_SPAY_PROD_SERVER,
    SPAY_PROD_COLLECTIONS: env.REACT_APP_SPAY_PROD_COLLECTIONS,
    SPAY_PROD_SETTLEMENT: env.REACT_APP_SPAY_PROD_SETTLEMENT,
    SPAY_PROD_PAYMENT_PAGE: env.REACT_APP_SPAY_PROD_PAYMENT_PAGE,
};

const paymentPage = {
    PAYMENT_PAGE: env.REACT_APP_SPAY_TEST_PAYMENT_PAGE,
    PAYMENT_PAGE_URL_NAME: env.REACT_APP_SPAY_PAYMENT_PAGE_TITLE
};

export { prodApiConfig, devApiConfig, paymentPage };
